module.exports = __webpack_public_path__ + "media/元宇宙會展應用服務-5G網站影片V2.9f7b68fe.mp4";